<template>
    <v-container fluid class="ma-0 pa-0">
        <v-row no-gutters>
            <v-col cols="12" class="text-center buttom-border table-head primary--text">
                <v-row no-gutters>
                    <v-col cols="1" class="text-center table-head primary--text">{{kpi.row_header}}</v-col>
                    <v-col cols="11">
                        <v-row no-gutters> 
                            <v-col cols="1" class="text-center table-head primary--text">
                                Estado
                            </v-col>
                            <v-col cols="2" class="text-center table-head primary--text">
                                <kpi-table-header :weeks="weeks1" @ordering="order" :ordered_week="kpi_doc_date_to_order" :order_symbol="kpi_doc_order_symbols[kpi_doc_order]" />
                            </v-col>
                            <v-col cols="2" class="text-center table-head primary--text">
                                <kpi-table-header :weeks="weeks2" @ordering="order" :ordered_week="kpi_doc_date_to_order" :order_symbol="kpi_doc_order_symbols[kpi_doc_order]" />
                            </v-col>
                            <v-col cols="2" class="text-center table-head primary--text">
                                <kpi-table-header :weeks="weeks3" @ordering="order" :ordered_week="kpi_doc_date_to_order" :order_symbol="kpi_doc_order_symbols[kpi_doc_order]" />
                            </v-col>
                            <v-col cols="2" class="text-center table-head primary--text">
                                <kpi-table-header :weeks="weeks4" @ordering="order" :ordered_week="kpi_doc_date_to_order" :order_symbol="kpi_doc_order_symbols[kpi_doc_order]" />
                            </v-col>
                            <v-col cols="2" class="text-center table-head primary--text">
                                <kpi-table-header :weeks="weeks5" @ordering="order" :ordered_week="kpi_doc_date_to_order" :order_symbol="kpi_doc_order_symbols[kpi_doc_order]" />
                            </v-col>
                            <v-col cols="1" class="text-center table-head primary--text" v-on:click="order('Año')">
                                <div v-if="kpi_doc_date_to_order == 'Año'">
                                    Año {{kpi_doc_order_symbols[kpi_doc_order]}}
                                </div>
                                <div v-else>
                                    Año
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="text-center table-head primary--text">
                <div class="scrollable">
                    <v-row no-gutters v-for="data in Object.keys(paginate_data)" :key="'row_' + Object.keys(paginate_data[data])[0]"> 
                        <template>
                            <v-col cols="12" class="table-head ">                            
                                <v-row no-gutters>
                                    <v-col cols="1" class="text-center table-head primary--text">
                                        <doc-text-field dense hide-details :value="Object.keys(paginate_data[data])[0]" kind="text" readonly :font_weight_black="Object.keys(paginate_data[data])[0]=='Total'" :primary_color_text="Object.keys(paginate_data[data])[0]=='Total'"></doc-text-field>
                                    </v-col>

                                    <v-col cols="11">
                                        <v-row  no-gutters v-for="state in states" :key="'row_' + Object.keys(paginate_data[data])[0] + '_' + state">
                                            <v-col v-if="!(Object.keys(paginate_data[data])[0]=='Total' && state=='% de carga')" cols="1" class="text-center table-head primary--text">
                                                <doc-text-field dense hide-details :value="state" kind="text" readonly :font_weight_black="Object.keys(paginate_data[data])[0]=='Total'" :primary_color_text="Object.keys(paginate_data[data])[0]=='Total'"></doc-text-field>
                                            </v-col>
                                            <v-col v-if="!(Object.keys(paginate_data[data])[0]=='Total' && state=='% de carga')" cols="2" class="text-center table-head primary--text">
                                                <kpi-table-row :weeks="weeks1" :kpis_data="kpis_data[Object.keys(paginate_data[data])[0]]" :data="state"></kpi-table-row>
                                            </v-col>
                                            <v-col v-if="!(Object.keys(paginate_data[data])[0]=='Total' && state=='% de carga')" cols="2" class="text-center table-head primary--text">
                                                <kpi-table-row :weeks="weeks2" :kpis_data="kpis_data[Object.keys(paginate_data[data])[0]]" :data="state"></kpi-table-row>
                                            </v-col>
                                            <v-col v-if="!(Object.keys(paginate_data[data])[0]=='Total' && state=='% de carga')" cols="2" class="text-center table-head primary--text">
                                                <kpi-table-row :weeks="weeks3" :kpis_data="kpis_data[Object.keys(paginate_data[data])[0]]" :data="state"></kpi-table-row>
                                            </v-col>
                                            <v-col v-if="!(Object.keys(paginate_data[data])[0]=='Total' && state=='% de carga')" cols="2" class="text-center table-head primary--text">
                                                <kpi-table-row :weeks="weeks4" :kpis_data="kpis_data[Object.keys(paginate_data[data])[0]]" :data="state"></kpi-table-row>
                                            </v-col>
                                            <v-col v-if="!(Object.keys(paginate_data[data])[0]=='Total' && state=='% de carga')" cols="2" class="text-center table-head primary--text">
                                                <kpi-table-row :weeks="weeks5" :kpis_data="kpis_data[Object.keys(paginate_data[data])[0]]" :data="state"></kpi-table-row>
                                            </v-col>
                                            <v-col v-if="!(Object.keys(paginate_data[data])[0]=='Total' && state=='% de carga')" cols="1" class="text-center table-head primary--text">
                                                <doc-text-field 
                                                    dense 
                                                    hide-details 
                                                    :value="kpis_data[Object.keys(paginate_data[data])[0]][state]['Año'][show_doc]" 
                                                    kind="text" 
                                                    readonly 
                                                    :font_weight_black="Object.keys(paginate_data[data])[0]=='Total'" 
                                                    :primary_color_text="Object.keys(paginate_data[data])[0]=='Total'"
                                                    :right_input="true"
                                                    :error="(show_doc == 'text') ? Boolean(kpis_data[Object.keys(paginate_data[data])[0]][state]['Año']['color']) : Boolean(kpis_data[Object.keys(paginate_data[data])[0]][state]['Año']['training_color'] )"
                                                    :errorColor="(show_doc == 'text') ? kpis_data[Object.keys(paginate_data[data])[0]][state]['Año']['color'] : kpis_data[Object.keys(paginate_data[data])[0]][state]['Año']['training_color']"
                                                ></doc-text-field>
                                            </v-col>
                                        </v-row> 
                                    </v-col> 
                                </v-row>
                            </v-col>
                        </template>
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="2">
                <doc-text-field 
                    label="Objetos por página"
                    dense 
                    hide-details 
                    v-model="limit" 
                    kind="number" 
                ></doc-text-field>
            </v-col>
            <v-col cols="7"></v-col>
            <v-col cols="1">
                <v-btn color="primary" :disabled="offset==0" @click="offset=offset-1">
                    <v-icon v-once>mdi-arrow-left</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="1">
                <doc-text-field 
                    label="Página"
                    dense 
                    hide-details 
                    :value="offset + 1" 
                    kind="number" 
                    readonly
                ></doc-text-field>
            </v-col>
            <v-col cols="1">
                <v-btn color="primary" :disabled="kpi_doc_data_ordering.length/limit < offset+1" @click="offset=offset+1">
                    <v-icon v-once>mdi-arrow-right</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="2"></v-col>
            <v-col cols="4">
                <v-select
                    label="Selector de histograma"
                    v-model="selected_histogram"
                    :items="histogram_values"
                    hide-details
                    return-object
                ></v-select>
            </v-col>
            <v-col cols="2">
                <v-btn color="primary" @click="get_histogram()">
                    Histograma
                </v-btn>
            </v-col>
            <v-col cols="4">
                <v-autocomplete 
                    v-if="selected_histogram['value']=='get_kpi_document_histogram'"
                    label="Usuario"
                    v-model="user"
                    :items="users"
                    item-key="id"
                    item-text="username"
                    autocomplete="off"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div :id="histogram_id" style="{width:100%}"></div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from 'vuex-map-fields';
import DocTextField from '../components/DocTextField.vue';
import KpiTableHeader from '../components/KpiTableHeader.vue';
import KpiTableRow from '../components/KpiTableRow.vue';
import { vuexPrefix } from "../store/vuex_utils";

export default {
    components: {
        DocTextField,
        KpiTableHeader,
        KpiTableRow,
    },
    props: {
        
    },
    data() {
        return {
            offset: 0,
            limit: 10,
            filters: {},
            histogram_id: 'document_histogram',
            selected_histogram : {'value': 'get_kpi_document_histogram', 'text': '% de carga por usuario/total'},
            histogram_values: [
                {'value': 'get_kpi_document_histogram', 'text': '% de carga por usuario/total'},
                {'value': 'get_kpi_document_histogram_by_company', 'text': '% de carga por empresa'},
            ],
            user: 'Total',
        };
    },
    computed: { 
        ...mapFields('kpis', [
            'kpi', 
            'kpis_data', 

            'kpi_doc_order',
            'kpi_doc_order_symbols',
            'kpi_doc_date_to_order',
            'kpi_doc_data_ordering',
            'show_doc',
            'kpi_id',
        ]),
        ...mapFields('kpis', vuexPrefix('kpi_filters_', ['docs'], 'kpi_filters.')),
        states() {
            let keys = Object.keys(this.kpis_data[Object.keys(this.kpis_data)[0]]);
            let keys_to_ignore = ['is_active', 'is_staff', 'is_trial']
            for (let i in keys_to_ignore) {
                let index = keys.indexOf(keys_to_ignore[i]);
                if (index > -1) {
                    keys.splice(index, 1);
                }
            }
            return keys;
        },
        weeks1() {
            try {
                let keys = Object.keys(this.kpis_data['Total']['Cargados']).slice(0, 3);
                return keys;
            } catch {
                return {};
            }
        },
        weeks2() {
            try {
                let keys = Object.keys(this.kpis_data['Total']['Cargados']).slice(3, 6);
                return keys;
            } catch {
                return {};
            }
        },
        weeks3() {
            try {
                let keys = Object.keys(this.kpis_data['Total']['Cargados']).slice(6, 9);
                return keys;
            } catch {
                return {};
            }
        },
        weeks4() {
            try {
                let keys = Object.keys(this.kpis_data['Total']['Cargados']).slice(9, 12);
                return keys;
            } catch {
                return {};
            }
        },
        weeks5() {
            try {
                let keys = Object.keys(this.kpis_data['Total']['Cargados']).slice(12, 15);
                return keys;
            } catch {
                return {};
            }
        },
        paginate_data() {
            let that = this;
            let start = this.offset * this.limit;
            let end = start + this.limit;
            let filtered_data = this.kpi_doc_data_ordering;
            if (Object.keys(this.kpi_filters_docs).length) {
                if (that.kpi_filters_docs.username) {
                    filtered_data = filtered_data.filter(function(item) {
                        return Object.keys(item)[0].includes(that.kpi_filters_docs.username);         
                    });
                } 
                if (!that.kpi_filters_docs.show_staff) {
                    filtered_data = filtered_data.filter(function(item) {
                        return !item[Object.keys(item)[0]]['is_staff']
                    });
                } 
                if (!that.kpi_filters_docs.show_trials) {
                    filtered_data = filtered_data.filter(function(item) {
                        return !item[Object.keys(item)[0]]['is_trial']
                    });
                } 
                if (!that.kpi_filters_docs.show_unactive) {
                    filtered_data = filtered_data.filter(function(item) {
                        return item[Object.keys(item)[0]]['is_active']
                    });
                } 
            }
            let data = filtered_data.slice(start, end);
            let total = this.kpi_doc_data_ordering.slice(-1);
            if (!data.includes(total[0])) {
                return data.concat(total);
            } else {
                return data;
            }
        },
        users() {
            let usernames = [];
            for (let i in this.kpi_doc_data_ordering) {
                let username = Object.keys(this.kpi_doc_data_ordering[i])[0];
                if (username == 'Total') {
                    usernames.unshift(username);
                } else {
                    usernames.push(username);
                }
            }
            return usernames;
        }
    },
    methods: {
        ...mapActions({
            order: "kpis/orderDocKpi",
            filterKpis: "kpis/filterKpis",
            getHistogram: "kpis/getHistogram",
        }),
        getColsWeeks(keys) {
            let lweeks = {};
            for (let i in keys) {
                lweeks[keys[i]] = Object.keys(this.kpis_data['Total'])[keys[i]];
            }
            return lweeks;
        },
        // order(week) {
        //     console.log(week)
        // }
        async get_histogram() {
            let inner = document.getElementById(this.histogram_id);
            if (inner)
                inner.innerHTML = "";

            let url = this.selected_histogram['value'] + '/?kpi_id=' + this.kpi_id + '&div_id=' + this.histogram_id;
            if (this.selected_histogram['value'] == 'get_kpi_document_histogram') {
                url = url + '&user=' + this.user
            }
            this.getHistogram(url).then(resp => {
                setTimeout(function() {
                    window.Bokeh.embed.embed_item(resp.data);
                });
            });
        },
    },
};
</script>

<style scoped>
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .scrollable {
        max-height: 490px;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .scrollable::-webkit-scrollbar {
        display: none;
    }
</style>